import { render, staticRenderFns } from "./EmailManagement.vue?vue&type=template&id=79ed362f&"
import script from "./EmailManagement.vue?vue&type=script&lang=js&"
export * from "./EmailManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports